
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './food.json';

const Food = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Food vocabulary, cooking terms, and dietary discussions. B2 level English exercises with grammar, reading, and speaking."
            level="B2"
            title="Food & Utensils"
            image="/Images/utensils1.webp"
            seoTitle="Free English Lesson Plans: Food and Utensils"
            seoDescription="Food vocabulary, cooking terms, and dietary discussions. B2 level English exercises with grammar, reading, and speaking."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Food;


